(function () {
  var OBSERVE_MS = 15000;

  function getGclid() {
    try {
      if (
        window.EnviroBuildAttribution &&
        typeof window.EnviroBuildAttribution.get === "function"
      ) {
        return window.EnviroBuildAttribution.get("gclid") || "";
      }
    } catch (e) {}

    return "";
  }

  function isZohoForm(iframe) {
    if (!iframe || iframe.tagName !== "IFRAME") return false;

    var src = iframe.getAttribute("src") || "";

    return (
      iframe.id === "zforms_iframe_id" ||
      src.indexOf("formperma") !== -1 ||
      src.indexOf("forms.zohopublic") !== -1
    );
  }

  function bridgeIframe(iframe) {
    if (!isZohoForm(iframe)) return;

    if (iframe.getAttribute("data-eb-gclid-bridged") === "1") {
      return;
    }

    var gclid = getGclid();
    if (!gclid) return;

    var src = iframe.getAttribute("src");
    if (!src) return;

    try {
      var url = new URL(src, window.location.href);

      /*
       * Respect a GCLID already supplied natively by Zoho.
       * Only fall back to EnviroBuild's persisted attribution
       * when the form URL does not already contain one.
       */
      if (!url.searchParams.get("gclid")) {
        url.searchParams.set("gclid", gclid);

        iframe.setAttribute("data-eb-gclid-bridged", "1");
        iframe.setAttribute("src", url.toString());
      } else {
        iframe.setAttribute("data-eb-gclid-bridged", "1");
      }
    } catch (e) {}
  }

  function scanForZohoForms(root) {
    root = root || document;

    /*
     * Handle the root itself if a newly inserted node is an iframe.
     */
    if (root.tagName === "IFRAME") {
      bridgeIframe(root);
    }

    if (!root.querySelectorAll) return;

    var iframes = root.querySelectorAll("iframe");

    for (var i = 0; i < iframes.length; i++) {
      bridgeIframe(iframes[i]);
    }
  }

  function initialise() {
    scanForZohoForms(document);

    /*
     * Zoho forms may be injected after initial page render, so watch
     * briefly for new iframes. Observer stops after 15 seconds.
     */
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;

        for (var j = 0; j < nodes.length; j++) {
          scanForZohoForms(nodes[j]);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, OBSERVE_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise);
  } else {
    initialise();
  }
})();